import React from 'react';
import PropTypes from 'prop-types';
import styles from './TabWithCount.module.css';

const TabWithCount = ({
  count,
  title,
  isSelected,
  handleClick,
  countColor,
  backgroundColor,
}) => {
  const possibleColors = ['blue', 'white', 'green', 'red'];

  const classForTabWrapper = isSelected
    ? possibleColors.includes(backgroundColor) && backgroundColor === 'green'
      ? styles.greenTab
      : possibleColors.includes(backgroundColor) && backgroundColor === 'white'
      ? styles.whiteTab
      : possibleColors.includes(backgroundColor) && backgroundColor === 'red'
      ? styles.redTab
      : styles.blueTab
    : styles.notSelected;

  const classForCount = isSelected
    ? possibleColors.includes(countColor) && countColor === 'red'
      ? styles.redCount
      : possibleColors.includes(countColor) && countColor === 'white'
      ? styles.whiteCount
      : possibleColors.includes(countColor) && countColor === 'green'
      ? styles.greenCount
      : styles.blueCount
    : possibleColors.includes(countColor) && countColor === 'red'
    ? styles.notSelectedRedCount
    : possibleColors.includes(countColor) && countColor === 'white'
    ? styles.notSelectedRedCount
    : possibleColors.includes(countColor) && countColor === 'green'
    ? styles.notSelectedGreenCount
    : styles.notSelectedBlueCount;

  const classForTitle =
    isSelected && (backgroundColor === 'green' || backgroundColor === 'red')
      ? styles.whiteTitle
      : styles.title;

  return (
    <div
      className={classForTabWrapper}
      onClick={handleClick}
      onKeyDown={handleClick}
      role="button"
      tabIndex={0}
      style={{
        cursor: 'pointer',
        outline: 'none',
      }}
    >
      <div className={styles.countTitleWrapper}>
        <span aria-label={`${title}-count`} className={classForCount}>
          {count}
        </span>
        <span className={classForTitle}>{title}</span>
      </div>
    </div>
  );
};

TabWithCount.propTypes = {
  count: PropTypes.number,
  title: PropTypes.string,
  isSelected: PropTypes.bool,
  handleClick: PropTypes.func,
  countColor: PropTypes.string,
};

export default TabWithCount;
